import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.INCIDENT_RULES, app: APP_PATHS.THREATS });
    context.validatePermissions({ isAllowed, preload });
  },
});
